module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACPSURBVDhPY2TAAoSLr/QDJXIYGBlY/jMwrHjboxMJlYIDJiiNAhgZGQJAmsBsBoYIsCAawKqRGEB/jYzggAD5CRn8Z5CB+REKHkBpMAAG2AlGkeIrv9EUEQWYyNEEAkz/Gf6vgbJJASewJgCRkiv3gZQChMfA8KZHB0PdEIpHrBqBAXYGygSBE1AaCTAwAAB7iBov9WSNcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus.png
// module id = 545
// module chunks = 1